import { z } from 'zod';
import type { UpdateWebhookRequestDto } from '@sara/api-client';

export const editWebhookFormSchema = z.object({
  url: z
    .string()
    .min(1, 'URL is required')
    .url('Enter a valid URL')
    .refine((value) => value.startsWith('https://'), {
      message: 'URL must use https://',
    }),
  label: z.string().max(100, 'Label must be 100 characters or fewer'),
});

export type EditWebhookFormValues = z.infer<typeof editWebhookFormSchema>;

export interface EditWebhookInitialValues {
  url: string;
  label: string | null;
}

/**
 * Build the minimal PATCH payload. Backend distinguishes "omit" (no change) from
 * `label: null` (clear). Empty-string label in the form maps to null when the
 * original had a label, or to "no change" when the original was already empty.
 */
export function toUpdatePatch(
  initial: EditWebhookInitialValues,
  current: EditWebhookFormValues
): UpdateWebhookRequestDto {
  const patch: UpdateWebhookRequestDto = {};

  if (current.url !== initial.url) {
    patch.url = current.url;
  }

  const currentLabel = current.label.trim() === '' ? null : current.label;
  if (currentLabel !== initial.label) {
    patch.label = currentLabel;
  }

  return patch;
}
